import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Helmet from 'react-helmet'
import AngleDown from 'react-icons/lib/fa/angle-down'

import slugify from '../utils/slugify'
import { color } from '../globalStyles'
import { Page, Container } from '../components/common'
import Content from '../components/Content'
import Meta from '../components/Meta'
import Header from '../components/Header'

const Item = styled.div`
  border-bottom: 1px solid ${color.lightGrey};
  padding: 1rem 0;

  .GlossaryItem--Content {
    display: none;
    margin-top: 1rem;
  }

  &.open {
    .GlossaryItem--Content {
      display: block;
    }
  }
`
const Title = styled.h4`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;

  svg {
    width: 2.5rem;
    height: 2.5rem;
  }

  .open & {
    svg {
      transform: scaleY(-1);
    }
  }

  ::selection {
    background: none;
  }
`

export default class Glossary extends React.Component {
  static propTypes = {
    glossary: PropTypes.array.isRequired
  }

  state = {
    open: []
  }

  handleClick = key => {
    this.setState(prevState => {
      let open = prevState.open
      const existingIndex = open.indexOf(key)
      if (existingIndex >= 0) {
        open.splice(existingIndex)
      } else {
        open.push(key)
      }
      return open
    })
  }

  sortGlossary = glossary => {
    glossary = glossary.filter(item => item.fields && item.fields.title)
    glossary.sort(
      (a, b) =>
        a.fields.title.toLowerCase() < b.fields.title.toLowerCase() ? -1 : 1
    )
    return glossary
  }

  render () {
    let { glossary } = this.props
    glossary = this.sortGlossary(glossary)
    const target = window.location.hash

    return (
      <Page bgWhite>
        <Helmet title='Glossary' />
        <Meta title='Glossary' />
        <Header small title='Glossary' subtitle='What does it mean' />
        <Container desktopOnly>
          {glossary &&
            glossary.map(item => {
              const { title, description } = item.fields
              const key = `GlossaryItem-${title}`
              const open =
                this.state.open.indexOf(key) >= 0 ||
                target.slice(1) === slugify(title)
              return (
                <Item key={key} className={open ? 'open' : ''}>
                  <Container>
                    <Title onClick={() => this.handleClick(key)}>
                      {title} <AngleDown />
                    </Title>
                    {description && (
                      <Content
                        className='GlossaryItem--Content'
                        source={description}
                      />
                    )}
                  </Container>
                </Item>
              )
            })}
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Glossary.js